var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"use-text-subtitle mb-3"},[_vm._v("\n    "+_vm._s(_vm.$t('faq.topic'))+"\n  ")]),_vm._v(" "),_c('ul',{staticClass:"topic-list"},_vm._l((_vm.topics),function(item,index){return _c('li',{key:index},[_c('a',{attrs:{"href":`#${index}`}},[_vm._v(_vm._s(item.header))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }